import { frontendURL } from 'dashboard/helper/URLHelper';
import { TEAM_MANAGEMENT_PERMISSION } from 'dashboard/constants/permissions';

import SettingsWrapper from '../SettingsWrapper.vue';
import HierarchyIndex from './HierarchyIndex.vue';

const meta = {
  permissions: ['administrator', TEAM_MANAGEMENT_PERMISSION],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/countries'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_countries',
          component: HierarchyIndex,
          props: { resourceType: 'country' },
          meta,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/branches'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_branches',
          component: HierarchyIndex,
          props: { resourceType: 'branch' },
          meta,
        },
      ],
    },
  ],
};
